import { MergeTag, SMSAutoResponse } from 'domains/content/types';
import { getMessageWithMergeTags } from 'utils';

export const getFormattedSmsAutoResponses = (autoResponses: SMSAutoResponse[], mergeTags: MergeTag[]) =>
    autoResponses?.map((autoResponse) => {
        const formattedText = getMessageWithMergeTags(mergeTags, autoResponse.text);

        return { ...autoResponse, text: formattedText };
    });
